import { useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';

import { Strings } from '@app/constants';
import { FormProvider } from '@app/components';
import { IMyProfileResponse } from '../types';
import { educationInformationSchema } from '../validators';
import { EducationsInfoForm } from '@app/sections/shared/education-info-form';
import { updateProfile } from './slice';
import { IAddEmployeeSchema } from '@app/modules/employees/types';

interface Props {
  row?: IMyProfileResponse;
}

const EduInformationPage = ({ row }: Props) => {
  const dispatch = useDispatch();
  const methods = useForm<IAddEmployeeSchema>({
    resolver: yupResolver(educationInformationSchema) as any,
    defaultValues: {
      educationInfo: {
        education: row?.education ? [...row.education] : [],
      },
    },
  });

  const onSubmit = (form: IAddEmployeeSchema) => {
    dispatch(updateProfile({ educationInfo: { ...form }, id: row?.id }));
  };
  return (
    <>
      <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
        <EducationsInfoForm
          labelSuffix
          graduation={row?.education}
          additionalButton={
            <Button
              variant="outlined"
              color="inherit"
              size="large"
              sx={{ width: 'max-content' }}
              type="submit"
            >
              {Strings.button.saveEducationalInformation}
            </Button>
          }
        />
      </FormProvider>
    </>
  );
};
export { EduInformationPage };
